module.exports = __webpack_public_path__ + "img/order-case02.8043a144.jpeg";